import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';

import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';

import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';

import {
  TranslateModule,
  TranslateService
} from '@ngx-translate/core';

import {
  faApple,
  faFacebookF,
  faGoogle,
  faMicrosoft
} from '@fortawesome/free-brands-svg-icons';

import { AdminService } from
  'src/app/services/admin/admin.service';

import { HeaderAuthComponent } from
  'src/app/components/layout/header-auth/header-auth.component';

@Component({
  selector: 'app-sign-in',
  standalone: true,

  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    HeaderAuthComponent
  ],

  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css'],

  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignInComponent implements OnInit {

  validateForm!: FormGroup;

  readonly faApple = faApple;
  readonly faGoogle = faGoogle;
  readonly faMicrosoft = faMicrosoft;
  readonly faFacebookF = faFacebookF;

  showPassword = false;

  loginError = '';
  private readonly apiUrl =
  'https://menuload.com/api';

  constructor(
    private readonly fb: FormBuilder,
    public readonly admin: AdminService,
    private readonly router: Router,
    private readonly translate: TranslateService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.initializeForm();

    if (this.admin.isAdmin()) {
      this.goToDashboard();
    }
  }

  private initializeForm(): void {
    this.validateForm = this.fb.group({
      user: [
        '',
        [
          Validators.required,
          Validators.email
        ]
      ],

      password: [
        '',
        [
          Validators.required
        ]
      ],

      remember: [true]
    });
  }


  async submitForm(): Promise<void> {
    this.loginError = '';

    if (this.validateForm.invalid) {
      this.validateForm.markAllAsTouched();
      this.cdr.markForCheck();

      return;
    }

    if (this.admin.loading) {
      return;
    }

    const data = {
      user: this.validateForm.value.user.trim(),
      password: this.validateForm.value.password
    };

    try {
      this.admin.loading = true;
      this.cdr.markForCheck();

      const isSuccess = await this.admin.login(data);

      if (!isSuccess) {
        this.loginError =
          this.translate.instant(
            'VALIDATION.INVALID_CREDENTIALS'
          ) || 'ელფოსტა ან პაროლი არასწორია.';

        return;
      }

      if (!this.admin.isAdmin()) {
        this.loginError =
          'ავტორიზაცია შესრულდა, მაგრამ სესია ვერ შეინახა.';

        console.error(
          'Login succeeded but admin session was not found.'
        );

        return;
      }

      await this.goToDashboard();

    } catch (error: any) {
      console.error('Login error:', error);

      this.loginError =
        error?.error?.message ||
        error?.message ||
        'ავტორიზაცია ვერ შესრულდა. სცადე თავიდან.';

    } finally {
      this.admin.loading = false;
      this.cdr.markForCheck();
    }
  }

  private async goToDashboard(): Promise<void> {
    await this.router.navigateByUrl('/', {
      replaceUrl: true
    });
  }

  get userControl() {
    return this.validateForm.get('user');
  }

  get passwordControl() {
    return this.validateForm.get('password');
  }

  loginWithGoogle(): void {
      window.location.href =
        `${this.apiUrl}/auth/google/redirect`;
    }

    loginWithApple(): void {
      window.location.href =
        `${this.apiUrl}/auth/apple/redirect`;
    }

    loginWithMicrosoft(): void {
      window.location.href =
        `${this.apiUrl}/auth/microsoft/redirect`;
    }

    loginWithFacebook(): void {
      window.location.href =
        `${this.apiUrl}/auth/facebook/redirect`;
    }
}